import { axiosSFS, params } from '@/api/instance'

const fetchLang = () => {
  return new Promise((resolve) => {
    resolve({
      Train: {
        SFS_LANG_ROW_1: 'TRAIN',
        SFS_LANG_ROW_2: 'DB train coupon for',
        SFS_LANG_ROW_3: 'From',
        SFS_LANG_ROW_4: 'To',
        SFS_LANG_ROW_5: 'Travel date',
        SFS_LANG_ROW_6: 'Class: 2',
        SFS_LANG_ROW_7: 'Information for the passengers',
        SFS_LANG_ROW_8:
          'This coupon is only valid on the date of issue and on the following day, for the mentioned route in second class and only if presented by the person named on the coupon. The coupon is not transferable. Miles will not be credited for this coupon.',
        SFS_LANG_ROW_9: 'The following terms and conditions apply',
        SFS_LANG_ROW_10:
          'Only the person named is entitled for travel and must present a valid ID. The coupon is only valid for passenger trains operated by Deutsche Bahn AG.',
        SFS_LANG_ROW_11: 'We now have on printed voucher'
      },
      RentalCar: {
        SFS_LANG_ROW_1: 'RENTAL CAR',
        SFS_LANG_ROW_2: 'Mobility voucher',
        SFS_LANG_ROW_3: 'We offer you complementary car hire',
        SFS_LANG_ROW_4: 'Name of passenger',
        SFS_LANG_ROW_5: 'Date',
        SFS_LANG_ROW_6: 'Rental pick-up location',
        SFS_LANG_ROW_7: 'Rental return location',
        SFS_LANG_ROW_8: 'Flight number',
        SFS_LANG_ROW_9: 'Vouchercode',
        SFS_LANG_ROW_10: 'Billing address',
        SFS_LANG_ROW_11: 'Vehicle size',
        SFS_LANG_ROW_12:
          'Information for guests: This voucher entitles you to hire a car from either of our car hire partners, Hertz or Sixt, on a single occasion and for a period of 24 hours from Start of hire. You will be entering into a contract of hire with one of these partners. This voucher pays for the car hire contract. The voucher only applies to cars collected from and returned to a location in Germany. The following terms and conditions apply: To be able to enter into a contract of hire you will need to show your driver’s license, as well as a credit card or EC card. Your credit card or EC card will be debited with at least EUR 160.00 as deposit when you hire the car. This amount will be re-credited to your credit card or EC card when you return the vehicle, unless the car hire partner is entitled to further Claims (e.g. if you have failed to fill the tank with fuel). The deposit will be increased if you take out additional insurance or choose other optional extras. For further Information please ask at the car hire Station when you hire the vehicle. You will have comprehensive insurance cover with an excess of EUR 850.00. Additional insurance (e.g. personal accident insurance or reduced excess) and other optional extras (e.g. child seat, Tyres suitable for winter, snow chains, ski rack) must be paid for in advance when you hire the car. You must return the vehicle to the relevant partner’s car hire Station at the specified destination within 24 hours of the Start of the rental period. You can return the vehicle outside the station’s office hours by depositing the car keys in a return safe specifically designed for this purpose. If you fail to return the vehicle within 24 hours, the relevant car hire partner will Charge you for each additional period of 24 hours or part thereof, at the rate shown on the car hire partner’s price list valid when you collected the vehicle. For details about current rates, please ask at the car hire partner’s Station when you collect the car. Please return the hire car to the relevant car hire partner’s Station at your destination with a full tank of fuel. We will refund the fuel costs for the journey between the point of the car’s collection and return, provided that you submit the receipt to the address shown below:  <billing_address>  <billing_address1>  <billing_address2>  <airline_name> This also applies if you were on a flight operated by another airline within the airberlin Group. If the vehicle is not returned with a full tank of fuel, the car hire partner will Charge you for tne costs of filling up with fuel on the basis of the currently valid price list. For details about these costs please ask at the car hire partner’s Station when you collect the car. We hope you will understand that airberlin is not able to refund those charges. The car hire is subject to the relevant partner’s general conditions of hire. These will be displayed at the partner’s Station and can be viewed there. This voucher Is only valid on the date of Issue, as well as on the following day, and only if presented by the person named on the voucher. This voucher is not transferable. Miles will not be created for this voucher.',
        SFS_LANG_ROW_13: 'There is a <rental_company_name> rental car arranged for your convenience',
        SFS_LANG_ROW_14: 'Pick up location',
        SFS_LANG_ROW_15: 'Drop of location',
        SFS_LANG_ROW_16: 'address',
        SFS_LANG_ROW_17: 'Information for the passengers',
        SFS_LANG_ROW_18:
          'This voucher entitles you to car hire of our car hire partner <rental_company_name>, on a single occasion and for a period of 24 hours from the start of hire. You will be entering into a contract of hire. This voucher pays for the car hire contract. The voucher only applies to cars collected from and returned to a location in Germany.',
        SFS_LANG_ROW_19: 'The following terms and conditions apply',
        SFS_LANG_ROW_20:
          "To be able to enter into a contract of hiire you will need to show your drivers licence, as well as a credit card or EC card. Your credit card or EC card will be debited with at least EUR 160,00 as deposit when you hire a car. This amount will be re-credited to your credit card or EC card when you return the vehicle, unless the car hire partner is entitled to further claims ( e.g. if you have failed to fill the tank with fuel). The deposit will be increased if you take out additional insurance or choose other optional extra's. For further information, please ask at the rental car station when you rent the vehicle."
      },
      Refreshment: {
        SFS_LANG_ROW_1: 'FOOD AND BEVERAGE VOUCHER',
        SFS_LANG_ROW_2: 'Please go to the <airline_name> service desk to get a printed copy of your refreshment voucher.',
        SFS_LANG_ROW_3:
          'With this below Virtual creditcard you will be able to pay for food and beverage at the airport F&B outlets that accept creditcards.',
        SFS_LANG_ROW_4:
          'We have reserved <amount> <currency> on this creditcard and it has a limited validity but at least until your onward travel if applicable.',
        SFS_LANG_ROW_5:
          'Please note that this Creditcard can only be used for Food and Beverage and not for other services or items.',
        SFS_LANG_ROW_6:
          'Please give the numbers on this creditcard at the counter when you have to pay for your order so they can enter the creditcard number in the credit card machine.',
        SFS_LANG_ROW_7:
          'If you have not used the entire sum on this creditcard at the same vendor you may use the remaining value at another vendor but always before your onward travel as your creditcard has a limited validity.'
      },
      Bus: {
        SFS_LANG_ROW_1: 'BUS TRANSPORT',
        SFS_LANG_ROW_2: 'Your Bus Travel Information',
        SFS_LANG_ROW_3: '<airline_name> arranged a bus transportation to the <drop_off_location>',
        SFS_LANG_ROW_4: 'Travel details',
        SFS_LANG_ROW_5: 'Pick up time',
        SFS_LANG_ROW_6: 'Pick up at',
        SFS_LANG_ROW_7: 'Additional information',
        SFS_LANG_ROW_8: 'Bus partner name',
        SFS_LANG_ROW_9:
          '<airline_name> apologizes for the inconvience and wishing you a save travel. <airline_name> Service Center'
      },
      Taxi: {
        SFS_LANG_ROW_1: 'TAXI TRANSFER VOUCHER',
        SFS_LANG_ROW_2:
          'With this below Virtual credit card issued by <airport_name> you will be able to pay for the taxi transportation from the <airport_name> to your Hotel.',
        SFS_LANG_ROW_3:
          'You can collect a taxi voucher from your <airline_name> service counter. Please make sure that you have recieved a handwritten Taxi voucher with clear instructions, before you go to the taxi stand.',
        SFS_LANG_ROW_4: 'YOUR ACCOMMODATION DETAILS',
        SFS_LANG_ROW_5: 'Address',
        SFS_LANG_ROW_6: 'Name',
        SFS_LANG_ROW_7: 'Tel'
      },
      PassengerDetail: {
        SFS_LANG_ROW_1: 'YOUR ONWARDS FLIGHT DETAILS',
        SFS_LANG_ROW_2: 'Name',
        SFS_LANG_ROW_3: 'pnr',
        SFS_LANG_ROW_4: 'From - To',
        SFS_LANG_ROW_5: 'Flight Number',
        SFS_LANG_ROW_6: 'Dep schedule',
        SFS_LANG_ROW_7: 'Arr schedule',
        SFS_LANG_ROW_8: 'Please plan ahead and give yourself enough time to go to the airport and prepare for your flight'
      },
      VirtualCreditCardDetails: {
        SFS_LANG_ROW_1: 'VIRTUAL CREDITCARDS',
        SFS_LANG_ROW_2:
          'The Virtual creditcard or Non card present credit card is a normal Mastercard transaction wich can be done by all credit Mastercard acceptants which have the possibility to type the numbers of the credidcard into the system.',
        SFS_LANG_ROW_3: 'As the virtual creditcard can obviously not be swiped through an machine.',
        SFS_LANG_ROW_4:
          'To accept the creditcard the acceptant will have to have the creditcard number, the expiry date and the CVC code which you find on your voucher.',
        SFS_LANG_ROW_5:
          'Your Airline has reserved a specific amount on the creditcard for you. Which in case of a taxi voucher should be sufficient to travel from the airport to your hotel and back but the creditcard wil only be valid for transportation.',
        SFS_LANG_ROW_6:
          'Or in case of a Refreshment Food and Beverage voucher, the amount on the voucher will be either <amount> <currency>, depending on the delay time.'
      }
    })
  })
}

const fetchTitleHeader = () => {
  return new Promise((resolve) => {
    resolve({
      Bus: {
        titleLink: 'Home',
        titleName: 'Home'
      },
      DownloadAllVoucher: {
        titleLink: 'Home',
        titleName: 'Home'
      },
      Error: {
        titleLink: 'SelectService',
        titleName: 'Appologies'
      },
      Flight: {
        titleLink: 'Home',
        titleName: 'Home'
      },
      FlightNextDay: {
        titleLink: 'Home',
        titleName: 'Home'
      },
      FlyToDay: {
        titleLink: 'Home',
        titleName: 'Home'
      },
      HotelBook: {
        titleLink: 'Home',
        titleName: 'Home'
      },
      HotelList: {
        titleLink: 'Home',
        titleName: 'Home'
      },
      Message: {
        titleLink: 'Home',
        titleName: 'Home'
      },
      MessageDetail: {
        titleLink: 'Home',
        titleName: 'Home'
      },
      MessagesList: {
        titleLink: 'Home',
        titleName: 'Home'
      },
      MyFlightUpdates: {
        titleLink: 'Home',
        titleName: 'Home'
      },
      NpsPage: {
        titleLink: 'Home',
        titleName: 'Home'
      },
      OverbookedPassenger: {
        titleLink: 'Home',
        titleName: 'Home'
      },
      PassengerDetail: {
        titleLink: 'Home',
        titleName: 'Home'
      },
      RebookCanx: {
        titleLink: 'Home',
        titleName: 'Home'
      },
      RebookDly: {
        titleLink: 'Home',
        titleName: 'Home'
      },
      Refreshment: {
        titleLink: 'Home',
        titleName: 'Home'
      },
      RentalCar: {
        titleLink: 'Home',
        titleName: 'Home'
      },
      SelectManualService: {
        titleLink: 'Home',
        titleName: 'Home'
      },
      SelectRoom: {
        titleLink: 'Home',
        titleName: 'Home'
      },
      SelectService: {
        titleLink: 'Home',
        titleName: 'Home'
      },
      ServiceAcceptance: {
        titleLink: 'Home',
        titleName: 'Home'
      },
      ServiceOptionRefund: {
        titleLink: 'Home',
        titleName: 'Home'
      },
      ServiceOptionRouting: {
        titleLink: 'Home',
        titleName: 'Home'
      },
      ServiceRefreshment: {
        titleLink: 'Home',
        titleName: 'Home'
      },
      Taxi: {
        titleLink: 'Home',
        titleName: 'Home'
      },
      TaxiCreditcard: {
        titleLink: 'Home',
        titleName: 'Home'
      },
      TaxiPhotoPay: {
        titleLink: 'Home',
        titleName: 'Home'
      },
      Train: {
        titleLink: 'Home',
        titleName: 'Home'
      },
      VirtualCreditCardDetail: {
        titleLink: 'Home',
        titleName: 'Home'
      },
      VirtualHelpdesk: {
        titleLink: 'Home',
        titleName: 'Home'
      },
      OptionTaxi: {
        titleLink: 'Home',
        titleName: 'Home'
      },
      ShareTaxi: {
        titleLink: 'Home',
        titleName: 'Home'
      },
      UpdatePhoneNumber: {
        titleLink: 'Home',
        titleName: 'Home'
      },
      CovidPortal: {
        titleLink: 'Home',
        titleName: 'Home'
      },
      MyDocuments: {
        titleLink: 'Home',
        titleName: 'Home'
      },
      WaitRebook: {
        titleLink: 'Home',
        titleName: 'Home'
      },
      PersonalDetails: {
        titleLink: 'Home',
        titleName: 'Home'
      },
      PhotoPay: {
        titleLink: 'Home',
        titleName: 'Home'
      },
      MonetaryCompensation: {
        titleLink: 'Home',
        titleName: 'Home'
      },
      CashPickUp: {
        titleLink: 'Home',
        titleName: 'Home'
      },
      Home: {
        titleLink: '',
        titleName: ''
      }
    })
  })
}

const fetchHeader = () => {
  return new Promise((resolve) => {
    resolve({
      logo: 'logo.png',
      langs: [
        { code: 'en', name: 'english' },
        { code: 'de', name: 'german' }
      ]
    })
  })
}

const fetchAirline = () => {
  const url = axiosSFS.defaults.baseURL + '/airline/' + params.airline_id + '/' + params.airport_code
  return axiosSFS.get(url).then((response) => {
    let res = response?.data
    if (res?.success) {
      return res.data
    }
  })
}

const insertInternalComment = (param) => {
  const url = axiosSFS.defaults.baseURL + '/internal-comment'
  return axiosSFS({
    method: 'post',
    url: url,
    data: {
      data: param
    }
  }).then(function (response) {
    let res = response?.data
    if (res?.success) {
      return res.data
    }
  })
}

const fetchOriginCode = (shortCode) => {
  const url = axiosSFS.defaults.baseURL + '/originCode/' + shortCode
  return axiosSFS.get(url).then((response) => {
    return response?.data
  })
}

const callBackCustomer = (param) => {
  const url = axiosSFS.defaults.baseURL + '/callback'
  return axiosSFS({
    method: 'post',
    url: url,
    data: { data: { group_id: param.group_id, secret: param.secret } }
  }).then(function (response) {
    return response?.data
  })
}
export { fetchLang, fetchHeader, fetchTitleHeader, fetchAirline, insertInternalComment, fetchOriginCode, callBackCustomer }
